module.exports = __webpack_public_path__ + "img/sofinancerji_logoti.c5f0711e.jpg";